

<script lang="ts">
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { AssistWidgetConfig } from "@kontextwerk/web-sdk/core"
  import EmbeddedChatFrame from "@kontextwerk/web-sdk/ui/assist/EmbeddedChatFrame.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import GhostButton from "../../../_shared/_modules/ghost-button"

  const {
    loading,
    error,
    load,
    embeddedChatConfig,
  }: {
    loading: boolean
    error: string | null
    load: () => Promise<void> | void
    embeddedChatConfig: AssistWidgetConfig | null
  } = $props()
</script>

{#if loading}
  <div class="state-block">
    <p>KehrAssist wird geladen…</p>
  </div>
{:else if error}
  <div class="state-block">
    <p>{error}</p>
    <GhostButton onclick={load}>Erneut laden</GhostButton>
  </div>
{:else}
  <EmbeddedChatFrame
    title="KehrAssist"
    height="70vh"
    config={embeddedChatConfig}
    showFullscreenShortcut={true}
  >
    {#snippet header()}
      <SectionTitle title="KehrAssist" brightBackground={true} />
    {/snippet}
  </EmbeddedChatFrame>
{/if}

<style lang="less">
  .state-block {
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;

    p {
      margin: 0;
    }
  }
</style>
